import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../css/slider.css';

import data from '../data/kategori1.json';
import kategori from '../data/kategori2.json'

export default function Slider2() {
  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear"
  };

  const set = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 3000,
    cssEase: "linear",
    rtl: true // Mengubah arah slide dari kiri ke kanan
  };

  const [jsonData, setJsonData] = useState([]);
  const [jsonKategori, setJsonKategori] = useState([]);
  useEffect(() => {
    setJsonData(data);
    setJsonKategori(kategori);
  }, []);

  return (
    <>
    <div className="main2">
      <Slider {...settings}>
        {jsonData.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.img} alt="slide" className="data-ekstra"/>
            <h1 className="jenis">{item.nama}</h1>
          </div>
        ))}
      </Slider>
    </div>

    <div className="main2 ke2">
      <Slider {...set}>
        {jsonKategori.map((item, index) => (
          <div className="card" key={index}>
            <img src={item.pict} alt="slide" className="data-ekstra"/>
            <h1 className="jenis">{item.text}</h1>
          </div>
        ))}
      </Slider>
    </div>
    </>
    

    
  );
}
